module.exports = __webpack_public_path__ + "static/media/watercolor woman.a2fe005b.png";